import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";

const MEDITATIONS = "MEDITATIONS";
const MEDITATION = "MEDITATION";
const apiFetcher = new ApiFetcher();
export function* fetchMeditations(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `meditations?${queryString}`);
    yield put({
      type: sagaListSuccess(MEDITATIONS),
      data: res.data
    });
  } catch (e) { }
}

export function* searchMeditations(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `meditations?${queryString}`);
    yield put({
      type: sagaSearchSuccess(MEDITATIONS),
      data: res.data
    });
  } catch (e) { }
}

export function* fetchMeditation(action) {
  try {
    const res = yield call(apiFetcher.find, "meditations", action.id);
    yield put({
      type: sagaOneSuccess(MEDITATION),
      data: res.data
    });
  } catch (e) { }
}

export function* createMeditation(action) {
  try {
    const res = yield call(apiFetcher.create, "meditations", action.data);

    yield put({
      type: sagaCreateSuccess(MEDITATION),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Meditation created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) { }
}

export function* updateMeditation(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "meditations",
      action.data,
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(MEDITATION),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Meditation details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) { }
}



// WEBPACK FOOTER //
// ./src/sagas/meditations.js